import http from './public'
export const rsfs = (params) => {
  // 认识师父类别树
  return http.fetchGet('/api/comprehendList.action', params)
}
export const enlightIndex = (params) => {
  return http.fetchGet('/api/enlighttalkList.action', { params: params })
}
export const enlightPage = (params) => {
  return http.fetchGet('/api/enlighttalkPage.action', { params: params })
}
export const enlightList = (params) => {
  return http.fetchGet('/api/queryEnlightTalkList.action', { params: params })
}
export const ebookPage = (params) => {
  // 电子书最新推荐
  return http.fetchGet('/api/ebookPage.action', { params: params })
}
export const ebookIndex = (params) => {
  // 电子书最新推荐
  return http.fetchGet('/api/ebookIndex.action', { params: params })
}
export const cardPage = (params) => {
  // 电子书最新推荐
  return http.fetchGet('/api/cardPage.action', { params: params })
}
export const cardDown = (params) => {
  return http.fetchGet('/api/cardDown.action', { params: params })
}
export const cardIndex = (params) => {
  // 电子书最新推荐
  return http.fetchGet('/api/cardIndex.action', { params: params })
}
export const pdfdown = (url) => {
  // 电子书下载
  return http.fetchGet(url, {
    responseType: 'arraybuffer'
  })
}
export const mbcategory = (params) => {
  // 墨宝类别
  let url = '/v2/mb'
  return http.fetchGet(url)
}
export const mb = (params) => {
  // 墨宝列表接口
  let url = '/v2/mb/' + params.category + '?page=' + params.page + '&per_page=' + params.per_page
  return http.fetchGet(url)
}
// export const blog = (params) => {
//   // blog接口
//   return http.fetchGet('/blogs/posts?categories=70&per_page=5&page=1', params)
// }
// export const imgIndex = (params) => {
//   // blog接口
//   return http.fetchGet('/blogs/posts?categories=1&per_page=4&page=1&orderby=date', params)
// }
// export const blogmedia = (params, mediaId) => {
//   // blog接口
//   return http.fetchGet('/media/' + mediaId, params)
// }
export const blog = (params) => {
  // blog接口
  return http.fetchGet('/blog/wp-json/wp/v2/posts?categories=70&per_page=5&page=1', params)
}
export const imgIndex = (params) => {
  // blog接口
  return http.fetchGet('/blog/wp-json/wp/v2/posts?categories=1&per_page=4&page=1&orderby=date', params)
}
export const blogmedia = (params, mediaId) => {
  // blog接口
  return http.fetchGet('/blog/wp-json/wp/v2/media/' + mediaId, params)
}

export const cardPageNew = (params) => {
  //  获取卡片
  return http.fetchPost('/fashuichangliu/card/list', params)
}
export const cardDownNew = (cardId) => {
  // 下载卡片 更新下载次数
  return http.fetchPut('/fashuichangliu/card/' + cardId)
}
export const cardIndexNew = (params) => {
  //  获取卡片目录
  return http.fetchPost('/fashuichangliu/card/type', params)
}



// WEBPACK FOOTER //
// ./src/api/index.js